module.exports = __webpack_public_path__ + "static/media/9DESA36.5a2f872d.jpg";